import { DefaultOptions, QueryClient } from '@tanstack/react-query';

export const defaultOptions: DefaultOptions = {
  queries: {
    staleTime: 0,
    gcTime: 1000 * 60 * 5,
    retry: false,
    retryDelay: (attemptIndex: number) => Math.min(1000 * 2 ** attemptIndex, 30000),
    refetchOnWindowFocus: false,
  },
};

// We can not useState or useRef in a server component, which is why we are
// extracting this part out into it's own file with 'use client' on top
export function makeQueryClient() {
  return new QueryClient({
    defaultOptions,
  });
}
